import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// "Cryptographic systems," / "end to end." — split for word stagger.
// "end to end" carries the teal underline.

const Hero = () => {
  const reduced = useReducedMotion();

  const wordVar = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <section
      style={{
        paddingTop: 'clamp(40px, 6vh, 80px)',
        paddingBottom: 'clamp(56px, 10vh, 120px)',
        position: 'relative',
        minHeight: 'calc(100svh - 76px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div className="hero-blur" style={{ left: '-220px', top: '0' }} />
      <div className="hero-blur" style={{ right: '-260px', top: '180px', opacity: 0.5 }} />

      <div className="page" style={{ position: 'relative', width: '100%' }}>
        <motion.h1
          style={{
            fontSize: 'clamp(36px, min(9.5vw, 13vh), 168px)',
            margin: 0,
            color: 'var(--ink)',
            maxWidth: '14ch',
            position: 'relative',
            fontFamily: "'Geist', system-ui, sans-serif",
            fontWeight: 600,
            letterSpacing: '-0.045em',
            lineHeight: 0.96,
          }}
          initial="hidden"
          animate="show"
          transition={{ staggerChildren: reduced ? 0 : 0.09, delayChildren: 0.15 }}
        >
          <span className="hero-line" style={{ whiteSpace: 'normal' }}>
            <motion.span
              style={{ display: 'inline-block' }}
              variants={wordVar}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              Cryptographic
            </motion.span>
            {' '}
            <motion.span
              style={{ display: 'inline-block' }}
              variants={wordVar}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              systems,
            </motion.span>
          </span>
          <span className="hero-line" style={{ whiteSpace: 'normal' }}>
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <motion.span
                style={{ display: 'inline-block' }}
                variants={wordVar}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              >
                end
              </motion.span>
              {' '}
              <motion.span
                style={{ display: 'inline-block' }}
                variants={wordVar}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              >
                to
              </motion.span>
              {' '}
              <motion.span
                style={{ display: 'inline-block' }}
                variants={wordVar}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              >
                end
              </motion.span>
              <motion.span
                aria-hidden="true"
                initial={reduced ? false : { scaleX: 0 }}
                animate={reduced ? undefined : { scaleX: 1 }}
                transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1], delay: 1.1 }}
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  bottom: '0.04em',
                  height: '0.06em',
                  background: 'var(--teal-bright)',
                  boxShadow: '0 0 22px var(--teal-glow)',
                  transformOrigin: 'left center',
                  borderRadius: 2,
                }}
              />
            </span>
            <motion.span
              style={{ display: 'inline-block', color: 'var(--ink)' }}
              variants={wordVar}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              .
            </motion.span>
          </span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: reduced ? 0 : 1.0 }}
        >
          <p
            className="prose prose-lead"
            style={{ marginTop: 'clamp(20px, 3.6vh, 40px)' }}
          >
            Ciphercurve is a software services company specialized in applied
            Cryptography solutions, distributed systems engineering and hardware
            security and acceleration.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center', marginTop: 'clamp(18px, 3vh, 32px)' }}>
            <a href="/services" className="btn-primary">
              Book a call <span className="arrow">→</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};


const Home = () => (
  <div>
    <Hero />
  </div>
);

export default Home;
